'use strict';
/* global Promise */
var showMoreResult = true;
var searchBase = require('base/search/search');
var common = require('brand_core/common');
var breakpoints = require('brand_core/components/breakpoints');
var customFilterButtons = require('brand_core/components/customFilterButtons');
var processInclude = require('base/util');
var filterCarousel = require('brand_core/components/filterCarousel');
const { debounce, isInViewport } = require('../utilities/utilities');
common.lazyLoad();
var refinementSelected = false;
var $refinementBar;
var $mobileRefinementBar;
var isPageDesigner = $('#isPageDesigner').length > 0;
var pageDesignerId = isPageDesigner && $('.storepage').length ? $('.storepage').get(0).id : null;
var headerHeightNew = $('header').outerHeight();
var previousSelectedFilters = []; // Track previously selected filters for removal announcements

function syncPlpSeoUrl(urlValue) {
    var rawUrl = urlValue && urlValue.href ? urlValue.href : urlValue;
    var absoluteUrl;

    try {
        absoluteUrl = new URL(rawUrl || window.location.href, window.location.origin).toString();
    } catch (e) {
        absoluteUrl = window.location.href;
    }

    var canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
        canonicalLink.href = absoluteUrl;
    }

    var ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
        ogUrl.setAttribute('content', absoluteUrl);
    }
}

function replaceUrlAndSync(urlValue) {
    window.history.replaceState(null, null, urlValue);
    syncPlpSeoUrl(urlValue);
}

// append/set params to url
function setURLSearchParam(key, value) {
    var url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.pushState({ path: url.href }, '', url.href);
    syncPlpSeoUrl(url.href);
}

function setFilterPanelOpenURLParam(value) {
    var url = new URL(window.location.href);
    url.searchParams.set('filterPanelOpen', value);
    window.history.replaceState({ path: url.href }, '', url.href);
}

function shouldOpenFilterPanelByDefault() {
    var filterPanelOpenParam = new URL(window.location.href).searchParams.get('filterPanelOpen');
    if (filterPanelOpenParam === 'true') {
        return true;
    }
    if (filterPanelOpenParam === 'false') {
        return false;
    }
    return $('.sort-filter-wrapper').attr('data-filter-panel-open-default') === 'true';
}

// scroll window when apply filter or sort
function scrollOnApplyRefinement() {
    var $splitPlpHero = $('.split-plp-header').find('.content-asset');
    if ($splitPlpHero.length) {
        var splitPlpHeroOffset = $splitPlpHero.offset().top;
        var splitPlpHeroOuter = $splitPlpHero.outerHeight();

        if (window.innerWidth < 1023) {
            $('html, body').scrollTop((splitPlpHeroOffset + splitPlpHeroOuter + 5) - headerHeightNew);
        } else {
            var scrollOffsetSplit = $('.header-banner').outerHeight() + $('.main-menu').outerHeight() + $('.split-plp-header').find('.content-asset').outerHeight();
            $('html, body').scrollTop(scrollOffsetSplit + 7);
        }
    } else {
        var $plpHero = $('.plp-hero-content-asset-container');
        if ($plpHero.children().length) {
            var plpHeroOffset = $plpHero.offset().top;
            var plpHeroHeight = $plpHero.outerHeight();
            if (!breakpoints.isDesktopView()) {
                if ($('.right-section-header').hasClass('is-sticky')) {
                    $('html, body').scrollTop(plpHeroHeight - 50);
                } else {
                    $('html, body').scrollTop(plpHeroHeight - 14);
                }
            } else {
                $('html, body').scrollTop((plpHeroOffset + plpHeroHeight) - 50);
            }
        } else {
            $('html, body').animate({ scrollTop: 0 }, 0);
        }
    }
}

function handleSortPrefix(value) {
    var $sortPrefix = $('.sort-dropdown .sort-prefix');
    var sortText = $sortPrefix.text().trim();
    if (value && value.length > 0) {
        if (sortText.indexOf(':') < 0) {
            $sortPrefix.text(sortText + ':');
        }
    } else {
        $sortPrefix.text(sortText.replace(/:/g, ''));
    }
}

// get/update srule
function updateSrule() {
    var urlParams = new URL(window.location.href).searchParams;
    var selectedSort = encodeURIComponent(urlParams.get('srule'));
    if (selectedSort) {
        var sortText = 'srule=' + selectedSort;
        var $customDropdown = $('.custom-dropdown');
        handleSortPrefix();
        $customDropdown.find('li').each(function () {
            if ($(this).attr('value') && $(this).attr('value').indexOf(sortText) > -1) {
                $(this).attr('selected', '');
                var text = $customDropdown.find('li[selected]').text();
                $customDropdown.find('.display-value').removeClass('d-none');
                $customDropdown.find('.display-value').text(text);
                handleSortPrefix(text);
            }
        });
    }
}

function initPLPTilesToShowAndSPLPGridParamsSessionStorage() {
    sessionStorage.setItem('splpGridParams', '');
    sessionStorage.setItem('plpTilesToShow', '');
    sessionStorage.setItem('plpTilesToShowDesktop', '');
    sessionStorage.setItem('plpTilesToShowTablet', '');
    sessionStorage.setItem('plpTilesToShowMobile', '');

    var urlParams = new URL(window.location.href).searchParams;
    var selectedSort = urlParams.get('srule');
    var selectedFilter = urlParams.toString().indexOf('prefv') > -1;

    var $splitProductGrids = $('.product-split-grid');
    if (!$splitProductGrids || $splitProductGrids.length === 0) {
        var $gridFooter = $('.grid-footer');
        if ($gridFooter && $gridFooter.length > 0) {
            var defaultPageSize = $gridFooter.data('default-page-size');
            if ((selectedSort || selectedFilter) && defaultPageSize) {
                sessionStorage.setItem('plpTilesToShow', defaultPageSize);
                sessionStorage.setItem('plpTilesToShowDesktop', defaultPageSize);
                sessionStorage.setItem('plpTilesToShowTablet', defaultPageSize);
                sessionStorage.setItem('plpTilesToShowMobile', defaultPageSize);
            }
        }
    } else if ($splitProductGrids && $splitProductGrids.length > 0) {
        var splitPLPGridParams = '';
        $splitProductGrids.each(function () {
            var $splpGridFooter = $(this).find('.grid-footer');
            var categoryId = $(this).data('category-id');
            if ($splpGridFooter && $splpGridFooter.length > 0) {
                var defaultSPLPSize = $splpGridFooter.data('default-page-size');
                if ((selectedSort || selectedFilter) && defaultSPLPSize) {
                    splitPLPGridParams += categoryId + ':' + defaultSPLPSize + '|' + defaultSPLPSize + '|' + defaultSPLPSize + '|' + defaultSPLPSize + ';';
                    sessionStorage.setItem('splpGridParams', splitPLPGridParams);
                }
            }
        });
    }
}

$(document).ready(function () {
    $('.lazy').unveil();
    customFilterButtons.handleFilterButtonsDisable();
    customFilterButtons.updateFilterButtonStates();
    filterCarousel.init();
    // Watch for custom event to re-init carousel if needed (e.g. after ajax)
    $(document).on('custom:filter:buttons:updated', function () {
        filterCarousel.init(); // Re-init handles re-attaching if DOM changed or just updating state
    });
    initPLPTilesToShowAndSPLPGridParamsSessionStorage();
});

/**
 * injects page designer grid regions into product grid
 * @param {string} response - html response from Search-UpdateGrid
 * @return {jquery} - updated response with injected grid regions
 */
function injectRenderedGridRegions(response) {
    var updatedResponse = null;
    var $gridRegionsToRender = $('#pd-gridRegionsToRender');
    if (response && $gridRegionsToRender && $gridRegionsToRender.length) {
        updatedResponse = $(response).map(function () {
            if (this.classList && this.classList.length) {
                for (let i = 0; i < this.classList.length; i++) {
                    var className = this.classList[i];

                    if (className && className.includes('pd-gridRegion')) {
                        var selectorClass = className;

                        var $gridRegionToRender = $gridRegionsToRender.find('.' + selectorClass);
                        if (!($gridRegionToRender && $gridRegionToRender.length > 0) && selectorClass.includes('pd-gridRegionLast')) {
                            selectorClass = selectorClass.replace('-desktop', '').replace('-tablet', '').replace('-mobile', '');
                            $gridRegionToRender = $gridRegionsToRender.find('.' + selectorClass);
                        }

                        if ($gridRegionToRender && $gridRegionToRender.length) {
                            var gridRegion = $gridRegionToRender.get(0);
                            if (gridRegion) {
                                this.innerHTML = gridRegion.innerHTML;
                            }
                        }
                    } else if (className && (className.includes('product-grid') || className.includes('product-split-grid'))) {
                        $(this).find('[class*="pd-gridRegion"').each(function () {
                            if (this.classList && this.classList.length) {
                                for (let j = 0; j < this.classList.length; j++) {
                                    var childClassName = this.classList[j];

                                    if (childClassName && childClassName.includes('pd-gridRegion')) {
                                        var childSelectorClass = childClassName;

                                        var $childGridRegionToRender = $gridRegionsToRender.find('.' + childSelectorClass);
                                        if (!($childGridRegionToRender && $childGridRegionToRender.length > 0) && childSelectorClass.includes('pd-gridRegionLast')) {
                                            childSelectorClass = childSelectorClass.replace('-desktop', '').replace('-tablet', '').replace('-mobile', '');
                                            $childGridRegionToRender = $gridRegionsToRender.find('.' + childSelectorClass);
                                        }

                                        if ($childGridRegionToRender && $childGridRegionToRender.length) {
                                            var childGridRegion = $childGridRegionToRender.get(0);
                                            if (childGridRegion) {
                                                this.innerHTML = childGridRegion.innerHTML;
                                            }
                                        }
                                    }
                                }
                            }
                        });

                        $(this).append($gridRegionsToRender);
                    }
                }
            }
            return this;
        });
    }
    return updatedResponse;
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    if ($(selector).hasClass('split-plp-header')) {
        $updates = $results.filter(selector);
    }

    var $updatedResponse = null;
    if (selector === '.product-grid') {
        $updatedResponse = injectRenderedGridRegions($updates);
    }
    if ($updatedResponse) {
        $(selector).empty().html($updatedResponse.html());
    } else {
        $(selector).empty().html($updates.html());
    }
}

function isFilterTagBarSticky() {
    var isSticky = false;
    var $sortFilterWrapper = $('.sort-filter-wrapper');
    if ($sortFilterWrapper && $sortFilterWrapper.length) {
        var sortFilterWrapperTop = $sortFilterWrapper.css('top');
        var currentTop = $sortFilterWrapper[0].getBoundingClientRect().top;

        if (sortFilterWrapperTop && currentTop) {
            sortFilterWrapperTop = parseFloat(sortFilterWrapperTop);
            sortFilterWrapperTop = parseInt(sortFilterWrapperTop, 10);
            currentTop = parseInt(currentTop, 10);

            isSticky = sortFilterWrapperTop >= currentTop;
        }
    }

    return isSticky;
}

function syncDesktopFilterButtonState() {
    if (!breakpoints.isDesktopView()) {
        return;
    }

    var panelIsOpen = !$('.filter-column').hasClass('hide-filter');
    var $desktopFilterButtons = $('button.filter-results:visible').filter(function () {
        return $(this).find('.show-filters, .hide-filters').length > 0;
    });
    var $filterResetButtons = $('.filter-tags-reset');

    $desktopFilterButtons.attr('aria-expanded', panelIsOpen ? 'true' : 'false');
    $desktopFilterButtons.each(function () {
        var $button = $(this);
        $button.find('.show-filters').toggleClass('d-none', panelIsOpen);
        $button.find('.hide-filters').toggleClass('d-none', !panelIsOpen);
    });

    $filterResetButtons.toggleClass('d-none', !panelIsOpen);
}

function updateStickyFilterTags() {
    var $filterTagsList = $('.filter-tags-container-desktop .filter-tags-list');
    var filterTagsListGap = 0;
    var $filterTags = null;

    if ($filterTagsList && $filterTagsList.length) {
        filterTagsListGap = $filterTagsList.css('gap');
        filterTagsListGap = filterTagsListGap ? parseFloat(filterTagsListGap) : 0;
        $filterTags = $filterTagsList.find('.filter-tag, .filter-tags-reset');
    }

    var isSticky = isFilterTagBarSticky();
    if (isSticky) {
        if ($filterTags && $filterTags.length) {
            var filterTagsListWidth = $filterTagsList.width();
            var filterTagsTotalWidth = 0;

            $filterTags.removeClass('d-none');
            $filterTags.each(function () {
                var filterTagWidth = $(this).width();

                var updatedFilterTagsTotalWidth = filterTagsTotalWidth + filterTagWidth;

                if (updatedFilterTagsTotalWidth > filterTagsListWidth) {
                    filterTagsTotalWidth = updatedFilterTagsTotalWidth;
                } else {
                    filterTagsTotalWidth += filterTagWidth;
                }

                filterTagsTotalWidth += filterTagsListGap;
            });
        }
    } else if ($filterTags && $filterTags.length) {
        $filterTags.removeClass('d-none');
    }
}

var debounceUpdateStickyFilterTags = debounce(updateStickyFilterTags, 200);

/**
 * Update applied filter after sort selection
 *
 * @return {undefined}
 */
function updateAppliedFilter() {
    var $selectedFilterList = $('.filter-bar ul.d-md-none');
    var selectedFilterCount = parseInt($('.filter-bar ul.d-md-none').children().eq(2).data('value'), 10) + 1;
    if ($selectedFilterList.children().length >= 3) {
        $selectedFilterList.children().last().html('+' + selectedFilterCount.toString() + 'More');
        $selectedFilterList.children().eq(1).remove();
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @return {undefined}
 */
function handleRefinements() {
    $refinementBar.find('.refinement.active').each(function () {
        $(this).removeClass('active');
        $('#refinementBar')
            .find('.' + $(this)[0].className.replace(/ /g, '.'))
            .addClass('active')
            .find('.js_refinement-heading')
            .attr('aria-expanded', 'true');
    });

    $mobileRefinementBar.find('.refinement.active').each(function () {
        $(this).removeClass('active');
        $('#mobileRefinementBar')
            .find('.' + $(this)[0].className.replace(/ /g, '.'))
            .addClass('active')
            .find('.js_refinement-heading')
            .attr('aria-expanded', 'true');
    });

    // Remove from memory
    $refinementBar = null;
    $mobileRefinementBar = null;
}

/**
 * Shows or hides reset button + reinitializes tag carousel on mobile
 * @param {Object} $results - jQuery DOM element
 */
function handleFilterTags($results) {
    $('.filter-tags-container').empty().html($results.find('.filter-tags-container').html());
    $('.filter-tags-list').toggleClass('d-none', $results.find('.filter-tags-container').find('.filter-tag').length === 0);

    // Get all current filter texts (use only desktop container to avoid duplicates)
    var currentFilterTexts = [];
    var currentFilterTextsOriginal = []; // Keep original text with "Currently Refined by" for selection announcements

    $('.filter-tags-container-desktop .sr-only.selected-assistive-text').each(function () {
        var text = $(this).data('announcement-text');
        if (text) {
            text = text.trim();
            // Store original text (with "Currently Refined by")
            currentFilterTextsOriginal.push(text.replace(/^selected\s*/i, '').trim());

            // Also store cleaned text (without "Currently Refined by") for comparison
            var cleanedText = text.replace(/^selected\s*/i, '').trim();
            cleanedText = cleanedText.replace(/^currently refined by\s*/i, '').trim();
            if (cleanedText) {
                currentFilterTexts.push(cleanedText);
            }
        }
    });

    var $announcer = $('#refinement-announcer');
    var announcementText = '';

    // Check if filters were removed (previous had more filters than current)
    if (previousSelectedFilters.length > currentFilterTexts.length) {
        // Find which filters were removed
        var removedFilters = previousSelectedFilters.filter(function (filter) {
            return currentFilterTexts.indexOf(filter) === -1;
        });

        // Check if ALL filters were removed at once (clear filters clicked)
        // This happens when: no filters remain AND more than 1 filter was removed
        if (currentFilterTexts.length === 0 && removedFilters.length > 1) {
            // Multiple filters were cleared at once
            announcementText = 'All filters removed';
        } else if (removedFilters.length > 0) {
            // Single filter was removed - use cleaned text without "Currently Refined by"
            var removedFilter = removedFilters[0]; // Take the first removed filter
            announcementText = 'Filter removed - ' + removedFilter;
        }
    } else if (currentFilterTextsOriginal.length > 0) {
        // Normal case: announce currently selected filters with "Currently Refined by"
        announcementText = currentFilterTextsOriginal.join(', ');
    }

    // Update the previous filters array for next comparison (use cleaned text)
    previousSelectedFilters = currentFilterTexts.slice(); // Make a copy

    // Clear announcer first, then set new text with a small delay for screen readers
    $announcer.text('');

    setTimeout(function () {
        $announcer.text(announcementText);
    }, 100);

    updateStickyFilterTags();
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @param {boolean} noResults - No search results container presence flag
 * @return {undefined}
 */
function parseResults(response, noResults) {
    var $results = $(response);
    if (!noResults) {
        var specialHandlers = {
            '.refinements': handleRefinements,
            '.filter-tags-container': handleFilterTags
        };

        // Save old refinement panels before changing
        $refinementBar = $('#refinementBar').clone();
        $mobileRefinementBar = $('#mobileRefinementBar').clone();

        var container = 'div.container-fluid.search-results.custom-padding.px-md-4';
        var containerEmpty = 'div.container-fluid.search-results.custom-padding';

        // Update DOM elements that do not require special handling
        [
            '.split-plp-header',
            '.grid-header',
            '.header-bar',
            '.header.page-title',
            '.product-grid',
            '.show-more',
            '.filter-bar',
            '.refinement-section',
            '.num-results span',
            '.mobile-sort',
            '.disclaimer-info-plpbanner',
            '.filter-header',
            '.filter-body',
            '.filter-footer',
            '.filter-button-wrapper',
            'div.container-fluid.search-results.custom-padding',
            'div.container-fluid.search-results.custom-padding.px-md-4'
            // '.right-section-header'
        ].forEach(function (selector) {
            var update = true;
            if (selector === '.show-more') {
                update = $results.find(selector).length <= 1;
            }

            // update sort dropdown menu
            if (selector === container || selector === containerEmpty) {
                update = false;
                if ($results.filter(selector).length > 0 && $results.filter(selector).find('.sort-filter-wrapper .sort-dropdown [role="menu"]')) {
                    var newSortMenu = $results.filter(selector).find('.sort-filter-wrapper .sort-dropdown [role="menu"]');
                    var existingSortMenu = $(selector).find('.sort-filter-wrapper .sort-dropdown [role="menu"]');
                    if (newSortMenu.length) {
                        existingSortMenu.empty().html(newSortMenu.html());
                    }
                }
            }

            if (update) {
                updateDom($results, selector);
            }
        });

        Object.keys(specialHandlers).forEach(function (selector) {
            specialHandlers[selector]($results);
        });
    } else {
        updateDom($results, '.search-results');
    }

    syncDesktopFilterButtonState();
}

function getSplitPLPGridParams() {
    var $gridFooters = $('.product-split-grid .grid-footer');
    var splitPLPGridParams = '';

    if ($gridFooters.length) {
        $gridFooters.each(function () {
            var $splitProductGrid = $(this).parents('.product-split-grid');
            var categoryId = $splitProductGrid.data('category-id');
            var splitProductGridProductTiles = $splitProductGrid.find('.product-tile').length;

            var splitProductGridProductTilesDesktop = splitProductGridProductTiles;
            var splitProductGridProductTilesTablet = splitProductGridProductTiles;
            var splitProductGridProductTilesMobile = splitProductGridProductTiles;
            $splitProductGrid.find('.hideGridTileDesktop').each(function () { if ($(this).find('.product-tile').length) splitProductGridProductTilesDesktop -= 1; });
            $splitProductGrid.find('.hideGridTileTablet').each(function () { if ($(this).find('.product-tile').length) splitProductGridProductTilesTablet -= 1; });
            $splitProductGrid.find('.hideGridTileMobile').each(function () { if ($(this).find('.product-tile').length) splitProductGridProductTilesMobile -= 1; });
            if ($(this).data('product-tiles-to-show')) splitProductGridProductTiles = $(this).data('product-tiles-to-show');
            if ($(this).data('product-tiles-to-show-desktop')) splitProductGridProductTilesDesktop = $(this).data('product-tiles-to-show-desktop');
            if ($(this).data('product-tiles-to-show-tablet')) splitProductGridProductTilesTablet = $(this).data('product-tiles-to-show-tablet');
            if ($(this).data('product-tiles-to-show-mobile')) splitProductGridProductTilesMobile = $(this).data('product-tiles-to-show-mobile');

            splitPLPGridParams += categoryId + ':' + splitProductGridProductTiles
                + '|' + splitProductGridProductTilesDesktop
                + '|' + splitProductGridProductTilesTablet
                + '|' + splitProductGridProductTilesMobile + ';';
        });
    }

    return splitPLPGridParams;
}

searchBase.applyFilter = function () {
    // Handle refinement value selection and reset click
    $('.container-fluid').on(
        'click',
        '.js-refinements li button, .js-resetall-filters, .filter-value button, .swatch-filter button, .filter-tag button, .filter-tags-reset button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.spinner().start();
            $(this).trigger('search:filter', e);
            var filterUrl = $(this).data('href');
            var urlParams = new URL(window.location.href).searchParams;
            var selectedSort = urlParams.get('srule');
            var selectedRefinements = filterUrl.split('?')[1];
            var historyUrl;
            if (selectedRefinements && selectedSort) {
                historyUrl = '?' + selectedRefinements + '&srule=' + selectedSort;
            } else if (!selectedRefinements && selectedSort) {
                historyUrl = '?srule=' + selectedSort;
            } else {
                historyUrl = '?' + selectedRefinements;
            }
            replaceUrlAndSync(historyUrl);

            // show same number of tiles as before filters were applied
            var $splitProductGrids = $('.product-split-grid');
            var splitPLPGridParams = sessionStorage.getItem('splpGridParams');
            if ($splitProductGrids.length) {
                if (!splitPLPGridParams || !splitPLPGridParams.length) {
                    splitPLPGridParams = getSplitPLPGridParams();
                    sessionStorage.setItem('splpGridParams', splitPLPGridParams);
                }

                if (!selectedSort && (!selectedRefinements || selectedRefinements.indexOf('prefv') === -1)) {
                    var parentCategoryID = $splitProductGrids.data('root-category-id');
                    if (parentCategoryID) {
                        filterUrl += '&pcgid=' + parentCategoryID;
                    }

                    if (splitPLPGridParams && splitPLPGridParams.length) {
                        filterUrl += '&splp=' + splitPLPGridParams;
                        sessionStorage.setItem('splpGridParams', '');
                    }
                }
            } else {
                var plpTilesToShow = sessionStorage.getItem('plpTilesToShow');
                var plpTilesToShowDesktop = sessionStorage.getItem('plpTilesToShowDesktop');
                var plpTilesToShowTablet = sessionStorage.getItem('plpTilesToShowTablet');
                var plpTilesToShowMobile = sessionStorage.getItem('plpTilesToShowMobile');

                var $gridFooter = $('.grid-footer');
                if ((!plpTilesToShow || !plpTilesToShow.length) && $gridFooter && $gridFooter.data('product-tiles-to-show')) {
                    plpTilesToShow = $gridFooter.data('product-tiles-to-show');
                    sessionStorage.setItem('plpTilesToShow', plpTilesToShow);
                }
                if ((!plpTilesToShowDesktop || !plpTilesToShowDesktop.length) && $gridFooter && $gridFooter.data('product-tiles-to-show-desktop')) {
                    plpTilesToShowDesktop = $gridFooter.data('product-tiles-to-show-desktop');
                    sessionStorage.setItem('plpTilesToShowDesktop', plpTilesToShowDesktop);
                }
                if ((!plpTilesToShowTablet || !plpTilesToShowTablet.length) && $gridFooter && $gridFooter.data('product-tiles-to-show-tablet')) {
                    plpTilesToShowTablet = $gridFooter.data('product-tiles-to-show-tablet');
                    sessionStorage.setItem('plpTilesToShowTablet', plpTilesToShowTablet);
                }
                if ((!plpTilesToShowMobile || !plpTilesToShowMobile.length) && $gridFooter && $gridFooter.data('product-tiles-to-show-mobile')) {
                    plpTilesToShowMobile = $gridFooter.data('product-tiles-to-show-mobile');
                    sessionStorage.setItem('plpTilesToShowMobile', plpTilesToShowMobile);
                }

                if (!selectedSort && (!selectedRefinements || selectedRefinements.indexOf('prefv') === -1)) {
                    if (plpTilesToShow && plpTilesToShow.length) {
                        filterUrl += '&start=0&sz=' + plpTilesToShow;
                        sessionStorage.setItem('plpTilesToShow', '');
                    }
                    if (plpTilesToShowDesktop && plpTilesToShowDesktop.length) {
                        filterUrl += '&dsize=' + plpTilesToShowDesktop;
                        sessionStorage.setItem('plpTilesToShowDesktop', '');
                    }
                    if (plpTilesToShowTablet && plpTilesToShowTablet.length) {
                        filterUrl += '&tsize=' + plpTilesToShowTablet;
                        sessionStorage.setItem('plpTilesToShowTablet', '');
                    }
                    if (plpTilesToShowMobile && plpTilesToShowMobile.length) {
                        filterUrl += '&msize=' + plpTilesToShowMobile;
                        sessionStorage.setItem('plpTilesToShowMobile', '');
                    }

                    var categoryID = $('.category-id').val();
                    if (categoryID) {
                        filterUrl += '&pcgid=' + categoryID;
                    }

                    if (splitPLPGridParams && splitPLPGridParams.length) {
                        filterUrl += '&splp=' + splitPLPGridParams;
                        sessionStorage.setItem('splpGridParams', '');
                    }
                }
            }

            var hasResetclass = $(this).hasClass('reset');
            var selectedFilterId = $(this).parent('[data-id]').data('id');
            $.ajax({
                url: filterUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: filterUrl,
                    selectedSort: selectedSort,
                    isPageDesigner: isPageDesigner,
                    pageId: pageDesignerId
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response, false);
                    handleSortPrefix();
                    if ($('.refinement-panel-desktop').hasClass('show')) {
                        $('.top-refinement-bar-btn').removeClass('d-none');
                    }

                    var filterCount = $('.refinements button span.selected').length;
                    if (filterCount > 0 || selectedSort) {
                        $('.split-plp-header').removeClass('d-none');
                    } else {
                        $('.split-plp-header').removeClass('d-none');
                    }

                    if (selectedSort) {
                        updateSrule();
                    }

                    if (hasResetclass) {
                        $('.refinement-url-value').val('');
                    } else {
                        $('.refinement-url-value').val(filterUrl);
                    }

                    $(document).trigger('custom:filter:buttons:updated');
                    $('body').trigger('quickview:loadButtons');

                    // Update sort
                    var sortLabel = $('.container-fluid [name=sort-order]').find(':selected').data('value');
                    if (sortLabel !== undefined) {
                        $('.num-results .placeholder').html(sortLabel);
                    }

                    var numResultsText = $('.num-results span:visible').text();
                    // Clear first, then announce after refinement-announcer (which has 100ms delay)
                    $('#num-results-announcer').text('');
                    setTimeout(function () {
                        $('#num-results-announcer').text(numResultsText);
                    }, 400); // 400ms delay to ensure it announces after refinement-announcer

                    common.lazyLoad();
                    searchBase.slider();
                    if (breakpoints.isDesktopView()) {
                        scrollOnApplyRefinement();
                    } else {
                        refinementSelected = true;
                    }

                    var $postSelected = $('.filter-button').parent(`[data-id="${selectedFilterId}"]`).find('button');
                    if ($postSelected.length > 0) {
                        // Store the original aria-label
                        var originalAriaLabel = $postSelected.attr('aria-label');

                        // Temporarily set empty aria-label to suppress announcement
                        $postSelected.attr('aria-label', '');

                        // Wait for live regions to announce (500ms), then focus
                        setTimeout(function () {
                            $postSelected.focus();

                            // Restore original aria-label after focus
                            setTimeout(function () {
                                if (originalAriaLabel) {
                                    $postSelected.attr('aria-label', originalAriaLabel);
                                } else {
                                    $postSelected.removeAttr('aria-label');
                                }
                            }, 100);
                        }, 500);
                    }
                },
                complete: function () {
                    $.spinner().stop();
                }
            });
        });
};

const updatePLPGridUrl = function () {
    var productTile = $('.product-grid .product-tile').length;
    var productTileDesktop = productTile;
    var productTileTablet = productTile;
    var productTileMobile = productTile;
    var $gridFooters = $('.grid-footer');

    var splitPLPGridParams = '';
    if ($gridFooters.length > 1) {
        splitPLPGridParams = getSplitPLPGridParams();
    } else if ($gridFooters.length) {
        $('.hideGridTileDesktop').each(function () { if ($(this).find('.product-tile').length) productTileDesktop -= 1; });
        $('.hideGridTileTablet').each(function () { if ($(this).find('.product-tile').length) productTileTablet -= 1; });
        $('.hideGridTileMobile').each(function () { if ($(this).find('.product-tile').length) productTileMobile -= 1; });
        if ($gridFooters.data('product-tiles-to-show')) productTile = $gridFooters.data('product-tiles-to-show');
        if ($gridFooters.data('product-tiles-to-show-desktop')) productTileDesktop = $gridFooters.data('product-tiles-to-show-desktop');
        if ($gridFooters.data('product-tiles-to-show-tablet')) productTileTablet = $gridFooters.data('product-tiles-to-show-tablet');
        if ($gridFooters.data('product-tiles-to-show-mobile')) productTileMobile = $gridFooters.data('product-tiles-to-show-mobile');
    }

    const url = new URL(window.location.href);
    if (splitPLPGridParams && splitPLPGridParams.length) {
        url.searchParams.set('splp', splitPLPGridParams);

        var $splitProductGrids = $('.product-split-grid');
        if ($splitProductGrids.length) {
            var parentCategoryID = $splitProductGrids.data('root-category-id');
            if (parentCategoryID) {
                url.searchParams.set('pcgid', parentCategoryID);
            }
        }
    } else {
        url.searchParams.set('start', '0');
        url.searchParams.set('sz', productTile);
        url.searchParams.set('dsize', productTileDesktop);
        url.searchParams.set('tsize', productTileTablet);
        url.searchParams.set('msize', productTileMobile);
    }
    url.searchParams.set('isBack', true);
    replaceUrlAndSync(url);
};

searchBase.handleBackbutton = function () {
    $(document).on('click', '.product-tile .pdp-link a, .product-tile .product-image-carousel a, .product-tile .primary-images a, .experience-region .pd-contentTile a, .product-quickview a.pdp-link',
    function () {
        if ($('.refinement-url-value').val() !== '' && typeof $('.refinement-url-value').val() !== 'undefined') {
            var pos = $(this).parents('.product-tile').index('.product-tile');
            var refinementUrl = $('.refinement-url-value').val();
            var hashParam = refinementUrl.split('#');
            if (hashParam.length > 1 && hashParam[1].indexOf('pos') > -1) {
                refinementUrl = hashParam[0];
            }
            refinementUrl += '#pos=' + pos;
            window.history.replaceState(refinementUrl, '', window.location.href);
        } else {
            var position = $(this).parents('.product-tile').index('.product-tile');
            window.history.replaceState(position, '', window.location.href);
        }
        updatePLPGridUrl();
    });

    if (window.history.state && window.history.state !== '' && $.isNumeric(window.history.state)) {
        common.lazyLoad();
        if (isNaN(window.history.state)) {
            window.history.state = 0;
        }
        // scrollWhenLoaded(window.history.state);
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('isBack', true);
    replaceUrlAndSync(url);
};

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * updates page designer content tile image sizes to match product tile height
 */
function handleContentTileResize() {
    var $contentTileImageWrappers = $('.pd-contentTile .image-wrapper');
    if ($contentTileImageWrappers) {
        var initialProductTileImageHeight = $('.product-tile-image-wrapper').innerHeight();
        if (initialProductTileImageHeight) {
            $contentTileImageWrappers.innerHeight(initialProductTileImageHeight);
        }
    }
}

function setCustomSelectWidth() {
    var windowsize = $(window).width();
    var isDesktop = windowsize > 992;
    if (isDesktop) {
        var urlParams = new URL(window.location.href).searchParams;
        var selectedSort = urlParams.get('srule');
        if (selectedSort) {
            $('.custom-select .sort-text').removeAttr('selected');
            $('.custom-select').find('option[selected]').each(function () {
                $(this).prop('selected', true);
            });
        } else {
            $('.custom-select .sort-text').prop('selected');
        }
        $('#width_tmp_option').html($('.custom-select option:selected').text());
        $('.custom-select').width($('#width_tmp_select').width());
    }
}

searchBase.showMore = function () {
    // Show more products
    $('.container-fluid').on('click', '.show-more button', function (e) {
        if (showMoreResult === true) {
            $.spinner().start();
            showMoreResult = false;
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            showMoreUrl += '&showAll=' + $('.show-all button').hasClass('active');
            e.preventDefault();

            var parentCategoryID = '';
            var $splitProductGrids = $('.product-split-grid');
            if ($splitProductGrids.length) {
                parentCategoryID = $splitProductGrids.data('root-category-id') || '';
            }

            var $splitPLPGrids = $('.product-split-grid');
            var splitPLPDefaultSectionTileCounts = '';
            if ($splitPLPGrids.length) {
                $splitPLPGrids.each(function () {
                    var sectionCategoryId = $(this).data('category-id');
                    var defaultSectionTileCount = $(this).data('default-section-tile-count');
                    if (sectionCategoryId && defaultSectionTileCount) {
                        splitPLPDefaultSectionTileCounts += sectionCategoryId + ':' + defaultSectionTileCount + ';';
                    }
                });
            }

            var $this = $(this);
            $this.trigger('search:showMore', e);
            if ($(this).data('url') !== '') {
                $.ajax({
                    url: showMoreUrl,
                    data: { selectedUrl: showMoreUrl, isPageDesigner: isPageDesigner, pageId: pageDesignerId, pcgid: parentCategoryID, sectionTileCounts: splitPLPDefaultSectionTileCounts },
                    method: 'GET',
                    success: function (response) {
                        var $splitProductGrid = $this.parents('.product-split-grid');

                        // unhide hidden tiles
                        var $tilesToUnhide = $('.hideGridTileDesktop, .hideGridTileTablet, .hideGridTileMobile').filter(function () {
                            if ($splitProductGrid.length) {
                                return ($splitProductGrid.has(this).length && !$(this).parents('#pd-gridRegionsToRender').length);
                            }
                            return !$(this).parents('#pd-gridRegionsToRender').length;
                        });
                        $tilesToUnhide.removeClass('hideGridTileDesktop').removeClass('hideGridTileTablet').removeClass('hideGridTileMobile');

                        var $gridFooter = $splitProductGrid.length ? $splitProductGrid.find('.grid-footer') : $('.grid-footer');
                        var updatedResponse = injectRenderedGridRegions(response);
                        if (updatedResponse) {
                            $gridFooter.replaceWith(updatedResponse);
                        } else {
                            $gridFooter.replaceWith(response);
                        }
                        updateSortOptions(response);
                        searchBase.slider();
                        common.lazyLoad();

                        if ($splitProductGrid.length) {
                            var splitProductGridProductTile = $splitProductGrid.find('.product-tile').length;
                            var splitProductGridProductTilesHiddenDesktop = 0;
                            var splitProductGridProductTilesHiddenTablet = 0;
                            var splitProductGridProductTilesHiddenMobile = 0;
                            $splitProductGrid.find('.hideGridTileDesktop').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    splitProductGridProductTilesHiddenDesktop += 1;
                                }
                            });
                            $splitProductGrid.find('.hideGridTileTablet').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    splitProductGridProductTilesHiddenTablet += 1;
                                }
                            });
                            $splitProductGrid.find('.hideGridTileMobile').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    splitProductGridProductTilesHiddenMobile += 1;
                                }
                            });
                            $splitProductGrid.find('.custom-product-tile').each(function () {
                                if ($(this).hasClass('mobile-size-0')) {
                                    splitProductGridProductTilesHiddenMobile += 1;
                                    splitProductGridProductTilesHiddenTablet += 1;
                                }
                                if ($(this).hasClass('desktop-size-0')) {
                                    splitProductGridProductTilesHiddenDesktop += 1;
                                }
                            });
                            $splitProductGrid.find('.p-count .page-size').text(splitProductGridProductTile);
                            $splitProductGrid.find('.p-count .page-size-desktop').text(splitProductGridProductTile - splitProductGridProductTilesHiddenDesktop);
                            $splitProductGrid.find('.p-count .page-size-tablet').text(splitProductGridProductTile - splitProductGridProductTilesHiddenTablet);
                            $splitProductGrid.find('.p-count .page-size-mobile').text(splitProductGridProductTile - splitProductGridProductTilesHiddenMobile);
                        } else {
                            var productTile = $('.product-grid .product-tile:not(#pd-gridRegionsToRender .product-tile)').length;
                            var productTilesHiddenDesktop = 0;
                            var productTilesHiddenTablet = 0;
                            var productTilesHiddenMobile = 0;
                            $('.hideGridTileDesktop').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    productTilesHiddenDesktop += 1;
                                }
                            });
                            $('.hideGridTileTablet').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    productTilesHiddenTablet += 1;
                                }
                            });
                            $('.hideGridTileMobile').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    productTilesHiddenMobile += 1;
                                }
                            });
                            $('.custom-product-tile:not(#pd-gridRegionsToRender .custom-product-tile)').each(function () {
                                if ($(this).hasClass('mobile-size-0')) {
                                    productTilesHiddenMobile += 1;
                                    productTilesHiddenTablet += 1;
                                }
                                if ($(this).hasClass('desktop-size-0')) {
                                    productTilesHiddenDesktop += 1;
                                }
                            });
                            $('.p-count .page-size').text(productTile);
                            $('.p-count .page-size-desktop').text(productTile - productTilesHiddenDesktop);
                            $('.p-count .page-size-tablet').text(productTile - productTilesHiddenTablet);
                            $('.p-count .page-size-mobile').text(productTile - productTilesHiddenMobile);
                        }
                        updatePLPGridUrl();
                        $('body').trigger('quickview:loadButtons');
                        $.spinner().stop();
                        showMoreResult = true;
                    },
                    error: function () {
                        $.spinner().stop();
                        showMoreResult = true;
                    }
                });
            } else {
                var $splitProductGrid = $this.parents('.product-split-grid');

                // unhide hidden tiles
                var $tilesToUnhide = $('.hideGridTileDesktop, .hideGridTileTablet, .hideGridTileMobile').filter(function () {
                    if ($splitProductGrid.length) {
                        return ($splitProductGrid.has(this).length && !$(this).parents('#pd-gridRegionsToRender').length);
                    }
                    return !$(this).parents('#pd-gridRegionsToRender').length;
                });
                $tilesToUnhide.removeClass('hideGridTileDesktop').removeClass('hideGridTileTablet').removeClass('hideGridTileMobile');

                var $gridFooter = $splitProductGrid.length ? $splitProductGrid.find('.grid-footer') : $('.grid-footer');
                $gridFooter.find('.grid-footer-count-btns').remove();

                // updateSortOptions(response);
                searchBase.slider();
                common.lazyLoad();

                if ($splitProductGrid.length) {
                    var splitProductGridProductTile = $splitProductGrid.find('.product-tile').length;
                    var splitProductGridProductTilesHiddenDesktop = 0;
                    var splitProductGridProductTilesHiddenTablet = 0;
                    var splitProductGridProductTilesHiddenMobile = 0;
                    $splitProductGrid.find('.hideGridTileDesktop').each(function () {
                        if ($(this).find('.product-tile').length) {
                            splitProductGridProductTilesHiddenDesktop += 1;
                        }
                    });
                    $splitProductGrid.find('.hideGridTileTablet').each(function () {
                        if ($(this).find('.product-tile').length) {
                            splitProductGridProductTilesHiddenTablet += 1;
                        }
                    });
                    $splitProductGrid.find('.hideGridTileMobile').each(function () {
                        if ($(this).find('.product-tile').length) {
                            splitProductGridProductTilesHiddenMobile += 1;
                        }
                    });
                    $splitProductGrid.find('.custom-product-tile').each(function () {
                        if ($(this).hasClass('mobile-size-0')) {
                            splitProductGridProductTilesHiddenMobile += 1;
                            splitProductGridProductTilesHiddenTablet += 1;
                        }
                        if ($(this).hasClass('desktop-size-0')) {
                            splitProductGridProductTilesHiddenDesktop += 1;
                        }
                    });
                    $splitProductGrid.find('.p-count .page-size').text(splitProductGridProductTile);
                    $splitProductGrid.find('.p-count .page-size-desktop').text(splitProductGridProductTile - splitProductGridProductTilesHiddenDesktop);
                    $splitProductGrid.find('.p-count .page-size-tablet').text(splitProductGridProductTile - splitProductGridProductTilesHiddenTablet);
                    $splitProductGrid.find('.p-count .page-size-mobile').text(splitProductGridProductTile - splitProductGridProductTilesHiddenMobile);
                    $gridFooter.data('product-tiles-to-show', splitProductGridProductTile);
                    $gridFooter.data('product-tiles-to-show-desktop', splitProductGridProductTile - splitProductGridProductTilesHiddenDesktop);
                    $gridFooter.data('product-tiles-to-show-tablet', splitProductGridProductTile - splitProductGridProductTilesHiddenTablet);
                    $gridFooter.data('product-tiles-to-show-mobile', splitProductGridProductTile - splitProductGridProductTilesHiddenMobile);
                } else {
                    var productTile = $('.product-grid .product-tile:not(#pd-gridRegionsToRender .product-tile)').length;
                    var productTilesHiddenDesktop = 0;
                    var productTilesHiddenTablet = 0;
                    var productTilesHiddenMobile = 0;
                    $('.hideGridTileDesktop').each(function () {
                        if ($(this).find('.product-tile').length) {
                            productTilesHiddenDesktop += 1;
                        }
                    });
                    $('.hideGridTileTablet').each(function () {
                        if ($(this).find('.product-tile').length) {
                            productTilesHiddenTablet += 1;
                        }
                    });
                    $('.hideGridTileMobile').each(function () {
                        if ($(this).find('.product-tile').length) {
                            productTilesHiddenMobile += 1;
                        }
                    });
                    $('.custom-product-tile:not(#pd-gridRegionsToRender .custom-product-tile)').each(function () {
                        if ($(this).hasClass('mobile-size-0')) {
                            productTilesHiddenMobile += 1;
                            productTilesHiddenTablet += 1;
                        }
                        if ($(this).hasClass('desktop-size-0')) {
                            productTilesHiddenDesktop += 1;
                        }
                    });
                    $('.p-count .page-size').text(productTile);
                    $('.p-count .page-size-desktop').text(productTile - productTilesHiddenDesktop);
                    $('.p-count .page-size-tablet').text(productTile - productTilesHiddenTablet);
                    $('.p-count .page-size-mobile').text(productTile - productTilesHiddenMobile);
                    $gridFooter.data('product-tiles-to-show', productTile);
                    $gridFooter.data('product-tiles-to-show-desktop', productTile - productTilesHiddenDesktop);
                    $gridFooter.data('product-tiles-to-show-tablet', productTile - productTilesHiddenTablet);
                    $gridFooter.data('product-tiles-to-show-mobile', productTile - productTilesHiddenMobile);
                }

                updatePLPGridUrl();
                $('body').trigger('quickview:loadButtons');
                $.spinner().stop();
                showMoreResult = true;
            }
        }
    });
};

searchBase.endlessScroll = function () {
    $('.container-fluid').on('click', '.show-all button', function () {
        $.spinner().start();
        $(this).addClass('active');
        $(this).closest('.grid-footer').find('.show-all button, .show-more button').addClass('d-none');
        $(this).closest('.grid-footer').find('.show-more button').click();

        $(window).scroll(function () {
            var $splitPLPActiveShowAllButtons = $('.product-split-grid .show-all button.active');
            var firstSplitPLPActiveShowAllButton = $splitPLPActiveShowAllButtons.length ? $splitPLPActiveShowAllButtons[0] : null;
            var product = $('.container, .container-fluid').find('.row.product-grid').find('.col-6').get(0);
            var productHeight = $(product).height();
            if ($(this).scrollTop() + 1 >= $('body').height() - $(window).height() - $('#footercontent').height() - productHeight) {
                if ($('.show-more button').length > 0) {
                    $('.show-more button').click();
                }
            } else if (firstSplitPLPActiveShowAllButton && ($(this).scrollTop() + 1 >= $(firstSplitPLPActiveShowAllButton).offset().top - $(window).height() - productHeight)) {
                $(firstSplitPLPActiveShowAllButton).click();
            } else if ('scrollPosition' in sessionStorage && performance.navigation.type === 2) {
                if ($(window).scrollTop() >= sessionStorage.getItem('scrollPosition')) {
                    sessionStorage.removeItem('scrollPosition');
                }
            }
            if ($(this).scrollTop() + 1 >= $('body').height() - $(window).height() - $('#footercontent').height()) {
                if ($('.show-more button').length > 0) {
                    $.spinner().start();
                }
            }

            setCustomSelectWidth();
            window.isAutoScrolledFlag = true;
        });
    });
};

searchBase.slider = function () {
    $('.primary-images').mouseenter(function () {
        if (breakpoints.isDesktopView()) {
            $('.carousel-control-prev', this).removeClass('d-none');
            $('.carousel-control-next', this).removeClass('d-none');
        }
    });
    $('.primary-images').mouseleave(function () {
        if (breakpoints.isDesktopView()) {
            $('.carousel-control-prev', this).addClass('d-none');
            $('.carousel-control-next', this).addClass('d-none');
        }
    });
};

searchBase.initializedImageCarousel = function () {
    $(document).on('beforeChange', '.product-image-carousel.slick-initialized', function (event, slick, currentSlide, nextSlide) {
        if (nextSlide) {
            var $imageCarousel = $(this);
            var nextImage = $imageCarousel.find('[data-slick-index="' + (nextSlide + 1) + '"]').find('.slide-img');
            var prevImage = $imageCarousel.find('[data-slick-index="' + (nextSlide - 1) + '"]').find('.slide-img');
            $imageCarousel.find('[data-slick-index="' + nextSlide + '"]').find('.alt-lazy').unveil(common.getSitePreference('lazyLoadThreshold'),
                function (element) {
                    var currentImage = $(element);
                    if (nextImage.length > 0 && nextImage.data('src') && nextImage.data('src') !== nextImage.attr('src')) {
                        if (currentImage.length > 0 && currentImage.attr('src')) {
                            nextImage.attr('src', currentImage.attr('src'));
                        }
                    }
                    if (prevImage.length > 0 && prevImage.data('src') && prevImage.data('src') !== prevImage.attr('src')) {
                        if (currentImage.length > 0 && currentImage.attr('src')) {
                            prevImage.attr('src', currentImage.attr('src'));
                        }
                    }
                },
                function (element) {
                    var errorSrc = $(element).attr('data-src-error');
                    var currentImage = $(element);
                    $(element).attr('src', errorSrc);
                    if (nextImage.length > 0 && nextImage.data('src') && nextImage.data('src') !== nextImage.attr('src')) {
                        if (currentImage.length > 0 && currentImage.attr('src')) {
                            nextImage.attr('src', currentImage.attr('src'));
                        }
                    }
                    if (prevImage.length > 0 && prevImage.data('src') && prevImage.data('src') !== prevImage.attr('src')) {
                        if (currentImage.length > 0 && currentImage.attr('src')) {
                            prevImage.attr('src', currentImage.attr('src'));
                        }
                    }
                }
            );
        }
    });
};

searchBase.filter = function () {
    $('.container-fluid').on('click', 'button.filter-results', function (e) {
        var $filterBtn = $(this);
        if (breakpoints.isDesktopView()) {
            e.preventDefault();
            var $filterColumn = $('.filter-column');
            var isClosed = $filterColumn.hasClass('hide-filter');

            $filterColumn.toggleClass('hide-filter', !isClosed);
            $('.plp-right-section').toggleClass('filter-panel-collapsed', !isClosed);
            syncDesktopFilterButtonState();
            setFilterPanelOpenURLParam(isClosed);

            $('body').removeClass('filter-panel-is-open');
            $('.modal-background').hide();
            return;
        }

        $('.filter-column')
            .css('padding-top', $('.js-header').outerHeight())
            .removeClass('hide-filter');
        $('body').addClass('filter-panel-is-open');
        $('.modal-background').show();

        if (!breakpoints.isDesktopView()) {
            var focusableSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

            setTimeout(function () {
                var $firstFocusable = $('.filter-column').find(focusableSelector).filter(':visible').filter(function () {
                    return $(this).closest('[aria-hidden="true"], [inert]').length === 0;
                })
                .first();
                if ($firstFocusable.length) {
                    $firstFocusable.focus();
                }
            }, 100);

            $(document).off('keydown.mobile-filter-trap').on('keydown.mobile-filter-trap', function (event) {
                if (event.key !== 'Tab' && event.keyCode !== 9) return;

                var isReachable = function () {
                    return $(this).closest('[aria-hidden="true"], [inert]').length === 0;
                };

                var $headerFocusable = $('header').find(focusableSelector).filter(':visible').filter(isReachable);
                var $filterFocusable = $('.filter-column').find(focusableSelector).filter(':visible').filter(isReachable);
                var allFocusable = $headerFocusable.toArray().concat($filterFocusable.toArray());

                if (!allFocusable.length) return;

                event.preventDefault();

                var currentIndex = allFocusable.indexOf(document.activeElement);

                if (event.shiftKey) {
                    var prevIndex = currentIndex <= 0 ? allFocusable.length - 1 : currentIndex - 1;
                    allFocusable[prevIndex].focus();
                } else {
                    var nextIndex = currentIndex >= allFocusable.length - 1 ? 0 : currentIndex + 1;
                    allFocusable[nextIndex].focus();
                }
            });

            $('.filter-column').data('filter-opener', $filterBtn[0]);
        }
    });

    $(window).on('scroll', function () {
        var isFilterBarSticky = isFilterTagBarSticky();
        if (isFilterBarSticky && !$('.sort-filter-wrapper').hasClass('is-sticky')) {
            $('.sort-filter-wrapper').addClass('is-sticky');
            updateStickyFilterTags();
        } else if (!isFilterBarSticky && $('.sort-filter-wrapper').hasClass('is-sticky')) {
            $('.sort-filter-wrapper').removeClass('is-sticky');
            updateStickyFilterTags();
        }
    });
};

searchBase.closeRefinements = function () {
    $('body').on('click', '.close-filter-column, .modal-background', function () {
        var $openerBtn = $('.filter-column').data('filter-opener');
        $('.filter-column').addClass('hide-filter');
        $('.plp-right-section').addClass('filter-panel-collapsed');
        syncDesktopFilterButtonState();
        if (breakpoints.isDesktopView()) {
            setFilterPanelOpenURLParam(false);
        }
        $('body').removeClass('filter-panel-is-open');
        $('.modal-background').hide();

        $(document).off('keydown.mobile-filter-trap');

        if ($openerBtn) {
            $($openerBtn).focus();
        }

        if (refinementSelected && !breakpoints.isDesktopView()) {
            scrollOnApplyRefinement();
            refinementSelected = false;
        }
    });
};

searchBase.closeRefinementsClickedOutside = function () {
    $('body').on('click, mousedown', function (event) {
        if ($('.refinement-bar').hasClass('show') && !$(event.target).closest('.refinement-bar').length) {
            $('.refinement-bar button.close').trigger('click');
        }
    });
};

function appendSkeleton(selectors) {
    return new Promise((resolve) => {
        $(selectors).each(function () {
            if (!$(this).children('.skeleton-overlay').length > 0) {
                $(this).append(`<div class='skeleton-overlay'><div class='skeleton-tile shimmer'></div></div>`); // eslint-disable-line
            }
        });

        resolve();
    });
}

searchBase.resetSortSelect = function () {
    $(document).ready(function () {
        if (breakpoints.isDesktopView()) {
            var openByDefault = shouldOpenFilterPanelByDefault();
            $('.filter-column').toggleClass('hide-filter', !openByDefault);
            $('.plp-right-section').toggleClass('filter-panel-collapsed', !openByDefault);
            syncDesktopFilterButtonState();
        } else {
            // Mobile always loads with the filter drawer closed, regardless of the merchandiser default
            $('.filter-column').addClass('hide-filter');
            $('.plp-right-section').addClass('filter-panel-collapsed');
        }

        updateSrule();
        if (performance.navigation.type === 2) {
            var skeletonSelectors = [
                $('.product-grid').children(),
                $('.refinement-container'),
                $('.js-refinements'),
                $('.results-reset'),
                $('.plp-header-text'),
                $('.breadcrumb'),
                $('.search-filter-sort-container').children(),
                $('.plp-hero-content-asset-container'),
                $('.plp-recomm-slot'),
                $('.seo-category-asset'),
                $('.plp-hero')
            ];

            if ('scrollPosition' in sessionStorage) {
                $('html,body').animate(
                    { scrollTop: sessionStorage.getItem('scrollPosition') }
                , 0, function () {
                    appendSkeleton(skeletonSelectors).then(function () {
                        $('#maincontent').css('visibility', 'visible');
                        $('.skeleton-overlay').fadeOut(1000, function () {
                            $(this).remove();
                        });
                    });
                });
            } else {
                if ($('#maincontent').css('visibility') === 'hidden') {
                    $('#maincontent').css('visibility', 'visible');
                }
                $('.skeleton-overlay').remove();
            }
        }
    });
};

searchBase.resize = function () {
    // Close refinement bar and hide modal background if user resizes browser
    $(window).resize(function () {
        if (!$('.btn.filter-results:visible').hasClass('collapsed')) {
            $('.btn.filter-results:visible').click();
        }

        $('.refinement-bar').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.container-fluid.search-results').siblings().attr('aria-hidden', false);

        debounceUpdateStickyFilterTags();
    });
};

searchBase.load = function () {
    $(window).on('load', debounce(function () {
        // load the page with the the ID in the URL, it will jump to that section
        var pageUrl = window.location.href;
        if (!(performance.navigation.type === 2)) {
            $('html, body').animate({ scrollTop: 0 }, 0);
        }

        if (pageUrl.includes('#')) {
            var pageId = pageUrl.substring(pageUrl.lastIndexOf('#') + 1);
            $(window).scrollTop($('#' + pageId).offset().top - 90);
        }
    }, 10));
};

searchBase.scrollWhenLoaded = function () {
    // This is intentionally empty
};

searchBase.resetFilter = function () {
    // This is intentionally empty
};

searchBase.sort = function () {
    $('.search-results').on('custom-dropdown:change', '.sort-dropdown', function (evt) {
        evt.preventDefault();
        $.spinner().start();
        var sortLabel = $(this).find('[selected]').data('value');
        if (sortLabel !== undefined) {
            $('.num-results .placeholder').html(sortLabel);
        }
        $(this).trigger('search:sort', this.value);
        handleSortPrefix(sortLabel);
        const urlParams = new URLSearchParams(this.value);
        var selectedSortOption = urlParams.get('srule');
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value, isPageDesigner: isPageDesigner, pageId: pageDesignerId },
            method: 'GET',
            success: function (response) {
                var $productGrid = $('.row.product-grid');

                var updatedResponse = injectRenderedGridRegions(response);
                if (updatedResponse) {
                    var $gridRegionsToRenderClone = $('#pd-gridRegionsToRender').clone(true);
                    $productGrid.empty().html(updatedResponse);
                    $productGrid.append($gridRegionsToRenderClone);
                } else {
                    $productGrid.empty().html(response);
                }

                $('.split-plp-header').removeClass('d-none');
                if ($(response).filter('.grid-footer').attr('data-page-view') === 'normal') {
                    $('.split-plp-header').addClass('d-none');
                }
                common.lazyLoad();
                if (!breakpoints.isDesktopView() && $('.filter-bar ul.d-md-none').children().length > 1) {
                    updateAppliedFilter();
                }
                scrollOnApplyRefinement();
                var $customDropdown = $('.custom-dropdown');
                $customDropdown.find('.display-value').removeClass('d-none');
                setURLSearchParam('srule', selectedSortOption);
                $('body').trigger('quickview:loadButtons');
            },
            complete: function () {
                $.spinner().stop();
            }
        });
    });
};

searchBase.resizePageDesignerContentTiles = function () {
    $(window).on('load', function () {
        handleContentTileResize();
    });

    $(window).on('resize', function () {
        handleContentTileResize();
    });
};

const executeBase = function () {
    processInclude(searchBase);
};

const stickySearchResultHeader = function () {
    const $searchResultHeader = $('.search-keyword-wrapper');

    if (isInViewport($('.right-section-header')[0])) {
        $searchResultHeader.removeClass('sticky-search-bar');
    } else {
        $searchResultHeader.addClass('sticky-search-bar');
    }
};

const onScrollHandler = function () {
    $(document).on('scroll', debounce(function () {
        if ($('.search-keyword-wrapper').length) {
            stickySearchResultHeader();
        }
    }, 10));
};

$(document).on('click', '.product-tile', function () {
    var scrollPosition = $(document).scrollTop();
    sessionStorage.setItem('scrollPosition', scrollPosition.toString());
});

searchBase.initCustomFilterButton = function () {
    $(document).on('click', '[data-filter-button], [data-custom-filter-button]', function (e) {
        if ($(this).is('a')) {
            e.preventDefault();
        }
        if ($(this).prop('disabled')) {
            return;
        }

        $.spinner().start();

        var $btn = $(this);
        var isSelected = $btn.attr('aria-pressed') === 'true';
        if (isSelected) {
            $btn.attr('aria-pressed', 'false');
        } else {
            $btn.attr('aria-pressed', 'true');
        }
        var hasResetClass = $btn.hasClass('reset');

        // #5 fix: toggle off when already selected, apply otherwise
        var filterUrl = isSelected
            ? customFilterButtons.buildClearFilterUrl()
            : customFilterButtons.buildApplyFilterUrl($btn);

        if (!filterUrl) {
            $.spinner().stop();
            return;
        }

        // Update browser URL bar (the AJAX call renders new content, replaceState keeps URL in sync)
        replaceUrlAndSync(filterUrl);

        var gridRegionLastIndexObj = $('#pd-gridRegionsToRender').data('grid-region-last-index-obj');
        $.ajax({
            url: filterUrl,
            data: {
                page: $('.grid-footer').data('page-number'),
                selectedUrl: filterUrl,
                gridRegionLastIndexObj: JSON.stringify(gridRegionLastIndexObj),
                isPageDesigner: isPageDesigner
            },
            method: 'GET',
            success: function (response) {
                var $results = $(response);

                var hasProducts = $results.find('.product-grid .product-tile').length > 0;
                var noResults = $('.search-results').find('.no-search-results-container').length > 0;

                if (hasProducts) {
                    parseResults(response, noResults);
                } else {
                    $('.search-results').html($results.find('.search-results').html());
                }

                handleSortPrefix();
                if ($('.refinement-panel-desktop').hasClass('show')) {
                    $('.top-refinement-bar-btn').removeClass('d-none');
                }

                var filterCount = $('.refinements button span.selected').length;
                if (filterCount > 0) {
                    $('.split-plp-header').addClass('d-none');
                } else {
                    $('.split-plp-header').removeClass('d-none');
                }

                if (hasResetClass) {
                    $('.refinement-url-value').val('');
                } else {
                    $('.refinement-url-value').val(filterUrl);
                }

                $(document).trigger('custom:filter:buttons:updated');

                $('body').trigger('quickview:loadButtons');

                // Update sort
                var sortLabel = $('.container-fluid [name=sort-order]').find(':selected').data('value');
                if (sortLabel !== undefined) {
                    $('.num-results .placeholder').html(sortLabel);
                }

                common.lazyLoad();
                searchBase.slider();
                if (breakpoints.isDesktopView()) {
                    scrollOnApplyRefinement();
                } else {
                    refinementSelected = true;
                }
            },
            complete: function () {
                $.spinner().stop();
            }
        });
    });
};

module.exports = {
    executeBase: executeBase,
    searchBase: searchBase,
    onScrollHandler: onScrollHandler
};
